// src/components/Layout.js
import React from "react";
import Header from "./Header";
import Home from "./Home";

import "./Layout.css";
//import Map from './Map'
import Footer from "./Footer";
//import InfoPopup from "./InfoPopup";

const Layout = () => {
  return (
    <div className="layout-container">
      <Header />
      <main className="layout-main">
        <Home />
        {/* <InfoPopup/> */}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
